// TODO: change this to configureStore
// TODO: check all components consuming store use provider rather than import

// eslint-disable-next-line
import React from 'react'
import { 
  createStore,
  applyMiddleware,
  compose
} from 'redux'
import throttle from 'lodash/throttle';
import { connectRouter, routerMiddleware } from 'connected-react-router'

import history from '../history';

// middleware
import thunkMiddleware from 'redux-thunk'
import createApiRequest from 'redux-api-request'
import { loadingBarMiddleware } from '@modules/loading-bar/loading-bar'
import {middleware as apiToToastMiddleware} from '@modules/toast/toast.module'
import queryMiddleware from '@utils/query.middleware'
import { middleware as countsMiddleware } from '@modules/counts/counts.module'
// helpers
import reducerRegistry from './reducerRegistry'
import stateLoader from './stateLoader'
import combine from './combine'

// reducers
import { reducer as toastrReducer } from 'react-redux-toastr-custom'
import { reducer as accountReducer } from '@modules/account/account.module'
import { loadingBarReducer } from 'react-redux-loading-bar'
import userModules from '@modules/user/user.module'
import jobModule from '@modules/job/job.module'
import noteModule from '@modules/note/note.module'
import timesheetModule from '@modules/timesheet/timesheet.module'
import countsModule from '@modules/counts/counts.module'

//
// Register reducers
//

// account
reducerRegistry.register('account', accountReducer);
// users
reducerRegistry.register('admin', userModules.admin.reducer);
reducerRegistry.register('client', userModules.client.reducer);
reducerRegistry.register('candidate', userModules.candidate.reducer);
// other resources
reducerRegistry.register('job', jobModule.reducer);
reducerRegistry.register('timesheet', timesheetModule.reducer);
reducerRegistry.register('note', noteModule.reducer);
reducerRegistry.register('counts', countsModule.reducer);
// UI reducers
reducerRegistry.register('toastr', toastrReducer);
reducerRegistry.register('loadingBar', loadingBarReducer);

// get initial state from localStorage
const initialState = stateLoader.loadState();

// init reducer registry
const rootReducer = combine(reducerRegistry.getReducers(), initialState)

// init api request middleware
const apiRequestMiddleware = createApiRequest();

// TODO: add api -> toast middleware


// init middleware
const middleware =[
  thunkMiddleware,
  routerMiddleware(history),
  loadingBarMiddleware,
  queryMiddleware,
  apiRequestMiddleware,
  apiToToastMiddleware,
  countsMiddleware,
]

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;


// init store
const store = createStore(
  connectRouter(history)(rootReducer),
	// rootReducer,
	stateLoader.loadState(),
  composeEnhancers(
    applyMiddleware(...middleware)
  )
)

// Replace the store's reducer whenever a new reducer is registered
reducerRegistry.setChangeListener(reducers => {
  store.replaceReducer(connectRouter(history)(combine(reducers, initialState)))
})

// save state to localStorage whenever it changes
store.subscribe(throttle(() => {
  // extract auth information for persistance (excluding loginMessage) 
  var { loginMessage, ...auth} = store.getState().auth;
  // save state 
  stateLoader.saveState({auth})
}, 1000))

export default store


// WEBPACK FOOTER //
// ./src/store/store.js